import { API } from '../Api';

// Lý do (khớp enum ReportPostValue của BE)
export const CLAN_REPORT_REASONS: { value: number; label: string }[] = [
  { value: 1, label: 'Nội dung không phù hợp' },
  { value: 4, label: 'Quấy rối / công kích' },
  { value: 2, label: 'Ngôn từ thù ghét (toxic)' },
  { value: 3, label: 'Bạo lực' },
  { value: 9, label: 'Nội dung nhạy cảm / khiêu dâm' },
  { value: 8, label: 'Nguy hại trẻ em' },
  { value: 6, label: 'Lừa đảo / spam' },
  { value: 10, label: 'Khác' },
];

export const reportClan = (payload: {
  clanId: string;
  clanName?: string;
  reason: number;
  content?: string;
}) => {
  // Gateway route ReportController "lách" version: {version}=report → /api/report/...
  // (khớp pattern report-profile-image, vì ReportController ở /api/Report không có /v1)
  return API.post<boolean>('/report/user-service/report-clan', {
    clanId: payload.clanId,
    clanName: payload.clanName ?? '',
    reason: payload.reason,
    content: payload.content ?? '',
  }).then((res) => res.data);
};

// ----- Admin -----
export interface ClanReport {
  id: string;
  clanId: string;
  clanName?: string;
  reportByUserId: string;
  reportByUserName?: string;
  reason: number;
  content?: string;
  stateReport: number; // 0 Pending, 1 Accepted, 2 Rejected
  createdAt: string;
}

export const getClanReports = (
  state?: number,
  pageNumber = 1,
  pageSize = 20
) => {
  const params: Record<string, number> = { pageNumber, pageSize };
  if (state !== undefined) params.state = state;
  return API.get<ClanReport[]>('/v1/user-service/admin/ReportClan/list', {
    params,
  }).then((res) => res.data ?? []);
};

export const handleClanReport = (reportId: string, accept: boolean) => {
  return API.post<boolean>('/v1/user-service/admin/ReportClan/handle', {
    reportId,
    accept,
  }).then((res) => res.data);
};
